import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Clock, Mail, Lock } from 'lucide-react';

const PreLaunchPage = () => {
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    // Recuperar email do localStorage se disponível
    const storedUser = localStorage.getItem('arena_stats_pending_user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        setUserEmail(user.email || '');
      } catch (e) {
        console.error('[PreLaunch] Erro ao recuperar email:', e);
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-green-900 to-slate-900 flex items-center justify-center p-4">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Main Card */}
      <div className="relative max-w-2xl w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-2xl bg-gradient-to-br from-green-400 to-green-600 shadow-2xl mb-6">
            <img 
              src="/vukz-logo.jpeg" 
              alt="Arena Stats" 
              className="w-16 h-16"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = '<div class="text-white text-4xl font-black">AS</div>';
              }}
            />
          </div>
          <h1 className="text-5xl font-black text-white mb-3">
            Arena<span className="text-green-400">Stats</span>
          </h1>
          <p className="text-xl text-green-300 font-semibold">
            A Rede Social Profissional do Esporte
          </p>
        </div>

        {/* Status Card */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          {/* Header with gradient */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 p-8 text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm mb-4">
              <Lock className="w-10 h-10 text-white" />
            </div>
            <h2 className="text-3xl font-black text-white mb-2">
              Você está na Lista VIP!
            </h2>
            <p className="text-green-100 text-lg">
              Sua conta está em pré-cadastro
            </p>
          </div>

          {/* Content */}
          <div className="p-8">
            {/* User Info */}
            {userEmail && (
              <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4 mb-6 flex items-center gap-3">
                <Mail className="w-5 h-5 text-green-600" />
                <div>
                  <p className="text-sm text-green-700 font-semibold">Cadastrado como:</p>
                  <p className="text-green-900 font-bold">{userEmail}</p>
                </div>
              </div>
            )}

            {/* Status Message */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <Clock className="w-7 h-7 text-green-600" />
                Lançamento em Breve
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed mb-4">
                Estamos preparando uma experiência única para conectar atletas, clubes e profissionais do esporte em uma rede social exclusiva.
              </p>
              <p className="text-gray-600 text-lg leading-relaxed">
                Seu cadastro foi recebido com sucesso e você faz parte da lista de primeiros acessos. 
                <span className="font-bold text-green-700"> Em breve, você receberá um e-mail com as instruções de acesso.</span>
              </p>
            </div>

            {/* Features Preview */}
            <div className="bg-gradient-to-br from-gray-50 to-green-50 rounded-2xl p-6 mb-8">
              <h4 className="text-lg font-bold text-gray-900 mb-4">O que esperar:</h4>
              <div className="space-y-3">
                {[
                  'Perfil profissional esportivo completo',
                  'Conexões com atletas, clubes e organizações',
                  'Feed social com estatísticas e rankings',
                  'Análises avançadas de desempenho',
                  'Agenda de competições e eventos'
                ].map((feature, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <p className="text-gray-700 font-medium">{feature}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Timeline */}
            <div className="bg-green-600 rounded-2xl p-6 text-center mb-8">
              <p className="text-green-100 text-sm font-semibold mb-2">FIQUE ATENTO</p>
              <p className="text-white text-2xl font-black mb-1">Liberação Gradual</p>
              <p className="text-green-200 text-sm">
                Os acessos serão liberados por ordem de cadastro
              </p>
            </div>

            {/* Actions */}
            <div className="space-y-3">
              <Link 
                to="/"
                className="block w-full bg-gradient-to-r from-green-600 to-green-700 text-white py-4 rounded-xl font-bold text-lg text-center hover:from-green-700 hover:to-green-800 transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                Voltar para Início
              </Link>
              
              <p className="text-center text-sm text-gray-500 pt-2">
                Já foi aprovado?{' '}
                <Link to="/login" className="text-green-700 font-bold hover:text-green-800">
                  Fazer login
                </Link>
              </p>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <div className="text-center mt-8">
          <p className="text-green-300 text-sm">
            Dúvidas? Entre em contato: <a href="mailto:contato@vukz.ai" className="font-bold text-white hover:text-green-200">contato@vukz.ai</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PreLaunchPage;
